<template>
    <table class="table p-0">
        <td width="30%"><input class="form-control p-0" v-on:change="update('username')" v-model="user.username"/></td>
        <td width="30%"><input class="form-control p-0" v-on:change="update('performance_id')" v-model="user.performance_id"/></td>
        <td width="15%"><input v-on:change="update('enable')"  :id="user.id + '_enable'" type="checkbox"  v-model="user.enable"/></td>
        <td width="15%"><input v-on:change="update('admin')" :id="user.id + '_admin'" type="checkbox"  v-model="user.admin"/></td>
        <td width="10%"><b-button class="btn-sm" variant="danger" v-on:click="_delete()">Delete</b-button></td>
    </table>       
</template>

<script>
/* eslint-disable */ 
export default {
    name: "userEdit",
    props: {
        user:{}
    },
    methods:{
        update(el){
            let currentObj = this;
            let params = new URLSearchParams();
            params.append('field', el);
            params.append('value', this.user[el])
            params.append('id', this.user.id)
            params.append('task', 'editUser');
            this.axios.post('https://www.aperturefilms.com.au/customer-portal/admin.php', params)
                .then(function (response) {
                    console.log(response.data) 
                })
                .catch(function (error) {
                    console.log(error);  
                });
      },
      _delete(){
            let currentObj = this;
            let params = new URLSearchParams();
            params.append('id', this.user.id)
            params.append('task', 'deleteUser');
            this.axios.post('https://www.aperturefilms.com.au/customer-portal/admin.php', params)
                .then(function (response) {
                    console.log(response.data)
                    if (response.data.success) {
                        currentObj.$emit("refresh");
                    }
                })
                .catch(function (error) {
                    console.log(error);  
                });
      },
    },

}
</script>
    
